import { Sudt } from "./PwUpTypes";
import { config } from "@ckb-lumos/lumos";

export const SUDT_WHITE_LIST: Sudt[] = [
  // layer1 sudt
  {
    symbol: "dCKB",
    name: "NexisDAO token",
    decimal: 8,
    logoURI:
      "data:image/png;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAQDAwQDAwQEAwQFBAQFBgoHBgYGBg0JCggKDw0QEA8NDw4RExgUERIXEg4PFRwVFxkZGxsbEBQdHx0aHxgaGxr/2wBDAQQFBQYFBgwHBwwaEQ8RGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhr/wAARCAAoACgDASIAAhEBAxEB/8QAGwAAAwACAwAAAAAAAAAAAAAAAAQGAwUCBwj/xAAqEAABBAEDAwMDBQAAAAAAAAACAAEDBBIFESITIVEVMkIUI4EkMUFxcv/EABkBAAMBAQEAAAAAAAAAAAAAAAMEBgIFAf/EACARAAICAgEFAQAAAAAAAAAAAAACAwQBEhETIjEyQiT/2gAMAwEAAhEDEQA/APeV29HRizl/DeVK29Xs23fk8QeA7I1e2Vu4ffgHBlHUCs+tyPJMZRkRcSLimYotlbJJX78jSaJ6lJkW++RZJ2rq9qq7NmUoeD7rL1a3puGDdXH3Y98lEXys+txvHMYgJCOIlxWki37RSVpKmrI3sduUrsd6Fji/b+W8IUro9t6lwO+4HwdCXzgpa1xJY9n8iRZbll7kjFTwsdTb5LeaxUepdk2beM+bLLYirDp4nGYkZY8ckZX1J9a/dIrfJPfWfqejv8sVylp52Ort8lpsbPr23RPDqb5Y8cf9K2rxVn08jkNhMRLjlyR3bp6gq/6WZW+TXDvmOPuQndHqPbux7t9sOboSnPA3WpNPHv4Kq7RjuwdOT8P4Urb0izUd+BSh5DuhC8U7V2tHKnUbyJYlvtiWSdqaRatu3Aog8n2QhaY4lKuk78OVVKjHRhYI2/t/KEIQStRMLjjB/9k=",
    sudtArgs: "0xe5451c05231e1df43e4b199b5d12dbed820dfbea2769943bb593f874526eeb55",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xe78165e8b96ceea99bf93bdb86cb5b63d32c265045d674bc53da7e444bb31e1a",
    ckbL2ContractAddress: "",
  },

  // bridged tokens
  // https://github.com/nervosnetwork/force-bridge/blob/e533240e544df816a09bbcb3d4a30f48f9775e67/configs/all-bridged-tokens.json
  {
    address: "0x0000000000000000000000000000000000000000",
    symbol: "ETH|eth",
    name: "Wrapped ETH (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=002",
    sudtArgs: "0x9657b32fcdc463e13ec9205914fd91c443822a949937ae94add9869e7f2e1de8",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x9623b3027c4718cab7b0b41521808bfc4a94a855638b20f5a5dc92e7e89b3234",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    symbol: "USDT|eth",
    name: "Wrapped USDT (ForceBridge from Ethereum)",
    decimal: 6,
    logoURI: "https://cryptologos.cc/logos/tether-usdt-logo.svg?v=002",
    sudtArgs: "0x1b89ae72b96c4f02fa7667ab46febcedf9b495737752176303ddd215d66a615a",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xaaa9cb573c6cb58d0dc29264d2270013f3c6882439310927a53f2263d4be410e",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    symbol: "DAI|eth",
    name: "Wrapped DAI (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/multi-collateral-dai-dai-logo.svg?v=002",
    sudtArgs: "0xdd97fe4f673ed231af188855f4ca8b1034153c8d4e40f5b4fae2afd5d3f53ccc",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x6c8fa633bfd8887ff1371fa6219e9a26b68d29aa37cb1e4fde639de0a82f5f28",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    symbol: "LINK|eth",
    name: "Wrapped LINK (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/chainlink-link-logo.svg?v=002",
    sudtArgs: "0xb4f59ca5a3e1b8bdbce38ca8742bcd922c2201d61090cddd4a053b3f786e3275",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x3e5897972ef4808e335230ad7d27abcf7f7c5bc741a15085a51d56bd7135a8dd",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55",
    symbol: "BAND|eth",
    name: "Wrapped BAND (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/band-protocol-band-logo.svg?v=013",
    sudtArgs: "0xf7d2b6a5e6c9ec564ce11e30e845d7e4ed9fd873eb3a426e9991d4a780d7c35b",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x63cd46b517a4c18bcbdab32bbb772df4abdc347f58f0ad0e097626d300d71e74",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    symbol: "BAT|eth",
    name: "Wrapped BAT (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/basic-attention-token-bat-logo.svg?v=002",
    sudtArgs: "0xe183387147be24ecb3ba04eb480b6042803b1c93954f9c5a0e5a506cd5571b6b",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x37e4f49f4350428eab16fb5bc9f43b7c92e9dba9c1c2477e9ec0f3f01df04da6",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    symbol: "SNX|eth",
    name: "Wrapped SNX (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/synthetix-network-token-snx-logo.svg?v=002",
    sudtArgs: "0xb31800b3c908eaf217a982cb2a0fb8df7ac047485c432634a079a8c158339020",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x8ee7351601efbaf209c028e334f87e37bc87014df9c3888d06a084240e76fa99",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    symbol: "UNI|eth",
    name: "Wrapped UNI (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/uniswap-uni-logo.svg?v=013",
    sudtArgs: "0xb52927f7f444eb178461d0fa8b62b67c4a043add18e36248c7e9734d8d077a7e",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x8ed6320fc1ad64ad4b3b72d32dfa8bd61c5bb31e1216219cbbe048255c8dd09d",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
    symbol: "YFI|eth",
    name: "Wrapped YFI (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/yearn-finance-yfi-logo.svg?v=013",
    sudtArgs: "0x7658a43a8ae5f3f9d24c2001815617a31c29a4131bf2d2a67a4006f553116e11",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x763b67b6492c04a8170a50925977f9c40872899b1b5cd2e83586069a108da393",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
    symbol: "BUSD|eth",
    name: "Wrapped BUSD (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/binance-usd-busd-logo.svg?v=002",
    sudtArgs: "0x232678824938dfd87a049122c4e244af88dad7faa79a262362f5bc5356ee4c64",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xd60190d1abd1f66c8534f12ea91c959cc510026be142defa93eff358d2b1af5b",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    symbol: "COMP|eth",
    name: "Wrapped COMP (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/compound-comp-logo.svg?v=013",
    sudtArgs: "0x82a6b63b13d9980c98b17810eb2599dc94c144c0ddd24fd24e8a7881d93323ff",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x3d3a84a2c2310c0ef024528e3dc7a17db77602ed3b08fb77d818df6023f5c783",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    symbol: "MKR|eth",
    name: "Wrapped MKR (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/maker-mkr-logo.svg?v=002",
    sudtArgs: "0xbfe64426d24c81113125b33d092655913c8c759e475403a418f4eab47f405dd9",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xc7c6b6758073b427a81f32e836e3a04975a59d4a8820f470aeffd7f916e7b56f",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x6fB3e0A217407EFFf7Ca062D46c26E5d60a14d69",
    symbol: "IOTX|eth",
    name: "Wrapped IOTX (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/iotex-iotx-logo.svg?v=002",
    sudtArgs: "0x8049b09170892d1b04b24c9c185704149d915ab29d6640a1c74bf85e823738f5",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x1db54391a61e81d68ee6ee74d0596bd18adb874e49896d3ee06b147e2337387a",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xA91ac63D040dEB1b7A5E4d4134aD23eb0ba07e14",
    symbol: "BEL|eth",
    name: "Wrapped BEL (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/belacoin-bela-logo.svg?v=013",
    sudtArgs: "0xbceed8fd2b30c9e246035890196fed4218e5bff472786f74c19d9b156607070b",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x4caeb571696189b9e1b285079ad54122c57a52e51d51d4b4d4d94cb11740b3e7",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
    symbol: "USDP|eth",
    name: "Wrapped USDP (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/paxos-standard-pax-logo.svg?v=002",
    sudtArgs: "0x160093179296127b43624ab641e2561540e18b1f1b8025d8d6830485201a16a1",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xa261478af43970076045822b4b1617476e10a9aaa09f86d8fb1ab220541b8915",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC|eth",
    name: "Wrapped USDC (ForceBridge from Ethereum)",
    decimal: 6,
    logoURI: "https://cryptologos.cc/logos/usd-coin-usdc-logo.svg?v=002",
    sudtArgs: "0x5c4ac961a2428137f27271cf2af205e5c55156d26d9ac285ed3170e8c4cc1501",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x797bfd0b7b883bc9dba43678e285999507c6d0b971a2740c76623f70636f4080",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9",
    symbol: "SXP|eth",
    name: "Wrapped SXP (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/swipe-sxp-logo.svg?v=002",
    sudtArgs: "0xf49a7d57cd50907d28c0e2ae57b559165ce08aa0ff074fb3b277f6dc5eb285ee",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xa7ba92a1a41e07b15d1c0104a707da2c830cf8f05eeccebe2f85978f3915792c",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
    symbol: "SUSHI|eth",
    name: "Wrapped SUSHI (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/sushiswap-sushi-logo.svg?v=013",
    sudtArgs: "0xd7a79519d220983c703fd90083c481fc3144daad7ea05728832cbc021f27c017",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x7bd2c3027abda767990528932deab7ad1b7d7d09f104ee453aa97c7ee73cec87",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    symbol: "AAVE|eth",
    name: "Wrapped AAVE (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/aave-aave-logo.svg?v=013",
    sudtArgs: "0xaf47fbc88c924f720fd8d4c0aea5dca8bd00ceecd9f8c2ab45415f6a5dd2ee97",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x0f5d923d76c53a78c5a3e0614a0220a7a31930002aa16ab1a07caba6b4ed0292",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x111111111117dC0aa78b770fA6A738034120C302",
    symbol: "1INCH|eth",
    name: "Wrapped 1INCH (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/1inch-1inch-logo.svg?v=013",
    sudtArgs: "0x5bea7b77283ac8a20bd4e848a67c68349a3880b67278a5565bbbc242a26d3e29",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x7a12b26b621b6cf6982247855388694743c4da97b18a4ff8ebdf6fb54c1c850f",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x3DB6Ba6ab6F95efed1a6E794caD492fAAabF294D",
    symbol: "LTO|eth",
    name: "Wrapped LTO (ForceBridge from Ethereum)",
    decimal: 8,
    logoURI: "https://cryptologos.cc/logos/lto-network-lto-logo.svg?v=002",
    sudtArgs: "0x33e2afa67434322b1368bf5064b31dc20021bcccc871aa5cc6a5380aa58c59f6",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xe09d1544de9b7befc3c1da7c80f4f4c8ab8bd9a0e19d34b91aa2e8655a5bce42",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    symbol: "MATIC|eth",
    name: "Wrapped MATIC (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/matic-network-matic-logo.svg?v=002",
    sudtArgs: "0xb571d967797059352785a0297b3ff740f17df1b97315c311b2c0e0107a0db5a8",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x21e9f5f95a5895cf490815000c5983bbd8cc4e1e1d5bf34504cf19c62385671b",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C",
    symbol: "BNT|eth",
    name: "Wrapped BNT (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/bancor-bnt-logo.svg?v=002",
    sudtArgs: "0x4192873b0a0aaeaa04372aa46ff2cd94a90ac1acaa7569458226febec4d6d5ed",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xb9f522c2f00109c462b264bcb450896f879bc0685f8ea1d713918acc6317ec30",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x56d811088235F11C8920698a204A5010a788f4b3",
    symbol: "BZRX|eth",
    name: "Wrapped BZRX (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/bzx-protocol-bzrx-logo.svg?v=013",
    sudtArgs: "0xc0ddc82e1a24ccdf637bf19424dfcaa79ccb0dd7bdb1f4fdc7be3457214aee44",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x22ce0fb7ca87fe7d18ab380a9c9231b6f53f29cb929bdac648de22ca78769ffb",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x814e0908b12A99FeCf5BC101bB5d0b8B5cDf7d26",
    symbol: "MDT|eth",
    name: "Wrapped MDT (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/measurable-data-token-mdt-logo.svg?v=013",
    sudtArgs: "0xe5738a780a759d2f7a1a4b33999d1a7e05d55e0a88efb6068a963aa84531fdbc",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x4137951ecccc3b66c7e189d53e7669f1e129558a825a8af7e98421bc1169ecb8",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
    symbol: "PNT|eth",
    name: "Wrapped PNT (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/pnetwork-pnt-logo.svg?v=013",
    sudtArgs: "0xbdfe9436470e847122230ec5119eed76ace9a99cca1db628cf8d42d334cc16f5",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x082c7e4702ef56187f9942e302a0b8ce594b848babfcc6beb23fc1f4b7c76c35",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xeca82185adCE47f39c684352B0439f030f860318",
    symbol: "PERL|eth",
    name: "Wrapped PERL (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/perlin-perl-logo.svg?v=002",
    sudtArgs: "0x34ae46f1112be6a0f3d17bdf34d64e8508c4e6a6c23ae352d0915e24ac767224",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x6c9d59ba10b86b3a41150ee8eb7ee6c3a0e3fb5960845b25c8c4d25074f581b7",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xba100000625a3754423978a60c9317c58a424e3D",
    symbol: "BAL|eth",
    name: "Wrapped BAL (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/balancer-bal-logo.svg?v=013",
    sudtArgs: "0xcce6d0ac83d2491f8b8bd3875f3577b9e77f08a0396cd2e9274f339eb76e08a4",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xc2297759f60ee161c03046a2b676a075896a19868fa9c195466941b49d6e90fb",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x5732046A883704404F284Ce41FfADd5b007FD668",
    symbol: "BLZ|eth",
    name: "Wrapped BLZ (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/bluzelle-blz-logo.svg?v=002",
    sudtArgs: "0xda58dca6d334b837dbeb1da27e3ee45039890555bbcadbbd59fa1f32faaa5d5b",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x4c69fea403b41150a8bbe8e0333c5e315328ff0e995a96963755070b3fd41b9d",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xDDB3422497E61e13543BeA06989C0789117555c5",
    symbol: "COTI|eth",
    name: "Wrapped COTI (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/coti-coti-logo.svg?v=013",
    sudtArgs: "0x70746eb3aeeefb93c7024332e3b129ac09dbdfd238e9a0ff7763ae1b2cd8193e",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xb6d8e114e9e1f4dad22174079ddd0d34f5a46424c84faa09ee65ff8ceca155e8",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xE1Be5D3f34e89dE342Ee97E6e90D405884dA6c67",
    symbol: "TRX|eth",
    name: "Wrapped TRX (ForceBridge from Ethereum)",
    decimal: 6,
    logoURI: "https://cryptologos.cc/logos/tron-trx-logo.svg?v=002",
    sudtArgs: "0xff7eb7296b2e6896274c37bdf949442f8cbb3f89f60d21d39367e2c93d917ad9",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xf285b1f49e6d7bbabb3465962cbd9a47d1dedf91ada184217727dc741b91a706",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x0000000000085d4780B73119b644AE5ecd22b376",
    symbol: "TUSD|eth",
    name: "Wrapped TUSD (ForceBridge from Ethereum)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/trueusd-tusd-logo.svg?v=002",
    sudtArgs: "0xeb83e2d417474fb5aeaf3ab13be413e445159ade6865bd28834c34f680b9339a",
    source: "Ethereum",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x6aba94f3de680b3e13f329d0c7b5b7a4a97d2d9758dc6cf4362b3e89051b60e9",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x0000000000000000000000000000000000000000",
    symbol: "BNB|bsc",
    name: "Wrapped BNB (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/binance-coin-bnb-logo.svg?v=002",
    sudtArgs: "0x578cd6ab8c0800e6fbc17b58633857dac5626883af89f842e79cb8f7af24de75",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xbad31c6b4dddf142e826088fb440421e0a58625c8f55fce7b3e0faaf503f1b7b",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    symbol: "BUSD|bsc",
    name: "Wrapped BUSD (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/binance-usd-busd-logo.svg?v=002",
    sudtArgs: "0x69c215249102308356778d58259c91c0f1988f6f5b07aa614921ee1803ea0059",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x0083e7d7f1f887394052fbc451e8173b49f0e39a503b51f08b9d8a643232c978",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x55d398326f99059fF775485246999027B3197955",
    symbol: "USDT|bsc",
    name: "Wrapped USDT (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/tether-usdt-logo.svg?v=002",
    sudtArgs: "0xfd6f1818fe746687ef5268f82ce1835ba1a94fdccee5f098a389aeed0067eb57",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x1d256d7f519f9a3ff148a5877b18045c61a051b76308fc8c644ebdac59acb5da",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
    symbol: "ETH|bsc",
    name: "Wrapped ETH (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=002",
    sudtArgs: "0xd61ddc3184767d677be0d741883779aa9513293c4eaa4e0687b5b1caf845edfe",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xc98c302c81300ac6e445988d1fe1e1305b2cf035ca1138f00645ee60dcb6acd2",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
    symbol: "BTCB|bsc",
    name: "Wrapped BTCB (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/bitcoin-btc-logo.svg?v=002",
    sudtArgs: "0x9ea7beb4a36469e00bb30dbac75e93672441b483d519556ba9d1424b9294eae5",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x718543e25dafcb56d99c6e28b9448a33e62500b06a5032874e9eb19f4d64063e",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    symbol: "WBNB|bsc",
    name: "Wrapped WBNB (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/binance-coin-bnb-logo.svg?v=002",
    sudtArgs: "0x29f425f897896c15ca11fd154d8e22ac56b5f49e683d0c88979ad44752fcd520",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x8409e3353023f9e146a34f16708d01367870c42bc92356718b5b474cd8ebfabd",
    ckbL2ContractAddress: "",
  },
  {
    address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    symbol: "USDC|bsc",
    name: "Wrapped USDC (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/usd-coin-usdc-logo.svg?v=002",
    sudtArgs: "0xcedd0f67f2d218ab992284ab343c2e729d2a124a1612592deaa9f8b8f8a581dd",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0xec426c6b32073eaadb2be5c843759863bc704503aab12bcb60994270e5831d01",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xa296aD1C47FE6bDC133f39555C1D1177BD51fBc5",
    symbol: "iBFR|bsc",
    name: "Wrapped iBFR (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://assets.coingecko.com/coins/images/18540/large/buffer.png",
    sudtArgs: "0x5e945aa680b40d9388d4988aee0aebdd2ad9185b6c0ebfd408fa974818de8b6a",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x022156d65c2d9b2f358dadbe845b178c2d753c40e61a4fd01e750e7f0f70fcee",
    ckbL2ContractAddress: "",
  },
  {
    address: "0xD41FDb03Ba84762dD66a0af1a6C8540FF1ba5dfb",
    symbol: "SFP|bsc",
    name: "Wrapped SFP (ForceBridge from BSC)",
    decimal: 18,
    logoURI: "https://cryptologos.cc/logos/safepal-sfp-logo.svg?v=017",
    sudtArgs: "0xc66b8a7f4869272e1fd0565535cb444c319b6baafd386c5857f08d87e396cfd5",
    source: "BSC",
    bridge: "ForceBridge",
    ckbExplorerUrl:
      "https://explorer.nervos.org/sudt/0x3ce86f7bbe28c3d209907075e5dcc8737e8ab57cd918f6a3a7b594f934481d80",
    ckbL2ContractAddress: "",
  },
].map<Sudt>((item) => ({
  name: item.name,
  symbol: item.symbol,
  decimals: item.decimal,
  type: {
    code_hash: config.predefined.LINA.SCRIPTS.SUDT.CODE_HASH,
    hash_type: config.predefined.LINA.SCRIPTS.SUDT.HASH_TYPE,
    args: item.sudtArgs,
  },
}));
